jQuery(function($) {
    // Add the glowing div inside each glowing-card
    $(".glowing-card").each(function() {
        var glowDiv = $('<div class="glow-effect"></div>');
        $(this).append(glowDiv);
    });

    // Update the position of the glow-effect on mousemove
    $(".glowing-card").on("mousemove", function(e) {
        var card = $(this);
        var glow = card.find('.glow-effect');
        
        var rect = card[0].getBoundingClientRect();

        // Calculate the position of the glow relative to the card
        var offsetX = e.clientX - rect.left - (glow.width() / 2);
        var offsetY = e.clientY - rect.top - (glow.height() / 2);

        // Apply the left and top properties to the glow-effect
        glow.css({
            'left': offsetX + 'px',
            'top': offsetY + 'px',
            'opacity': 0.1 
        });
    });

    // When the mouse leaves the card, hide the glow
    $(".glowing-card").on("mouseleave", function() {
        var glow = $(this).find('.glow-effect');
        glow.css('opacity', '0');
    });
});
